import React from 'react';
import type { ModalFuncProps } from 'antd';
import { Modal } from 'antd';
import { useIntl } from 'umi';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { removeToken } from '@/utils/apiUtils';

export const getModalConfig = (intl) => ({
  okText: intl.formatMessage({ id: '确认' }),
  cancelText: intl.formatMessage({ id: '取消' }),
  className: 'web-ant-modal',
  icon: <ExclamationCircleFilled />,
  centered: true,
});

const useModalMethod = () => {
  const intl = useIntl();
  // 警告信息弹窗.
  const warning = ({ className, ...otherProps }: ModalFuncProps = {}) =>
    Modal.warning({
      ...getModalConfig(intl),
      className: `web-ant-modal ${className}`,
      ...otherProps,
    });
  // 普通确认弹窗
  const confirm = ({ className, ...otherProps }: ModalFuncProps = {}) =>
    Modal.confirm({
      ...getModalConfig(intl),
      className: `web-ant-modal ${className}`,
      ...otherProps,
    });
  // 提示信息弹窗
  const info = ({ className, ...otherProps }: ModalFuncProps = {}) =>
    Modal.info({
      ...getModalConfig(intl),
      className: `web-ant-modal ${className}`,
      ...otherProps,
    });
  // 退出确认弹窗
  const quitConfirm = (options: ModalFuncProps = {}) =>
    confirm({
      icon: null,
      title: (
        <span style={{ fontWeight: 'bold', color: '#13a07b' }}>
          {intl.formatMessage({ id: '温馨提示' })}
        </span>
      ),
      content: intl.formatMessage({ id: '确认放弃当前操作，并退出' }),
      onOk() {
        removeToken();
        window.top.close();
      },
      ...options,
    });
  return [{ warning, confirm, quitConfirm, info }];
};

export default useModalMethod;
